module.exports = __webpack_public_path__ + "img/bi.bibe5f159.svg";